"use strict";

var PropTypes = require("prop-types");

module.exports = {
  refType: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.elementType })])
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-aria-menubutton/dist/propTypes.js
// module id = 55
// module chunks = 0